export const PublicPages=  {
    'sr': {
        contact: 'kontakt',
        privacyPolicy: 'politika-privatnosti',
        tos: 'uslovi-koriscenja',
        about: 'o-nama'
    },
    'en': {
        contact: 'contact',
        privacyPolicy: 'privacy-policy',
        tos: 'terms-and-conditions',
        about: 'about-us'
    }
}
